import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-3826">
      <div className="max-w-4xl mx-auto text-center" data-id="element-3827">
        <div className="bg-white/10 p-8 rounded-2xl backdrop-blur-sm inline-block mb-6" data-id="element-3828">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Spinner%20Logo.jpg" alt="Spinner Logo" className="h-24 md:h-32 w-auto mx-auto" data-id="element-3829" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-3830">
          SPINNER Machine Tool
        </h1>
      </div>
    </div>;
}